import { useCallback, useEffect } from 'react';

import { redirectToG2 } from 'services/auth/g2AuthorizationParams';

export const getG2SignInOptions = (callbackUrl = window.location.href) => ({
  callbackUrl,
});

const redirectToG2SignIn = () => {
  redirectToG2(getG2SignInOptions());
};

const useUserAuthDialog = (options = {}) => {
  const { openByDefault } = options;

  useEffect(() => {
    if (openByDefault) {
      redirectToG2SignIn();
    }
  }, [openByDefault]);

  const handleOpen = useCallback(() => {
    redirectToG2SignIn();
  }, []);

  const handleClose = useCallback(() => undefined, []);

  const ModalWrapper = useCallback(() => null, []);

  return [ModalWrapper, handleOpen, handleClose, false];
};

export default useUserAuthDialog;
